// extracted by mini-css-extract-plugin
module.exports = {"idle-modal__body":"idle-modal_idle-modal__body__fooVG","idle-modal__text":"idle-modal_idle-modal__text__TTRa7","idle-modal__footer":"idle-modal_idle-modal__footer__uIdoL"};